import { render } from "./LessonDetailModal.vue?vue&type=template&id=0a7ffeba"
import script from "./LessonDetailModal.vue?vue&type=script&lang=js"
export * from "./LessonDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__